<div class="header">
  <div class="header-section header-section-start">
    <app-global-search />
  </div>
  <div class="header-section header-section">
    <div class="header-title">{{ appGlobals.$headerTitle | async }}</div>
  </div>
  <div class="header-section profile-section">
    <div class="profile">
      <div class="welcome-text">
        <span class="welcome" i18n="@@welcome">Welcome</span>
        <span class="profile-name">{{
          (appGlobals.$LoggedInUserData | async)?.userName
        }}</span>
      </div>
      <div class="profile-image-container">
        <app-user-avatar
          class="profile-image"
          [userEmail]="$safeNavigationMigration((appGlobals.$LoggedInUserData | async)?.email)"
        />
      </div>
    </div>
    <app-notification-bell *ngIf="notificationsEnabled" />
  </div>
</div>
